/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { useEffect } from 'react'
import { Modal } from 'antd-mobile'
import { observer } from 'mobx-react'
import { ModalBg } from '@styles/base.style'
import { Button, CloseBtn } from '@styles/button.style'
import { AdvSlideUpModalStyle } from '@styles/modal'
import BettorGiftContent from './BettorGiftContent'
import useRootStore from '@store/useRootStore'
import { useOnMount, useOnUnmount } from '@utils/reactExt'

interface MessageContentDrawerProps {
  nick: string
  isCustomProfile: boolean
  profile: string
  visible: boolean
  setVisible: (arg: boolean) => void
  onAction?: () => void
  onCancel?: () => void
}

const BettorGiftContentPopup: React.FC<MessageContentDrawerProps> = (props: MessageContentDrawerProps) => {
  const { nick, isCustomProfile, profile, visible, setVisible, onAction, onCancel } = props
  const { globalStore } = useRootStore()
  const onClickBettorHeartContentPopupCloseButton = () => setVisible(false)

  useEffect(() => {
    globalStore.updateVisibleModalList(visible, 'BettorGiftContentPopup:visible')
    return () => {
      globalStore.removeVisibleModalList('BettorGiftContentPopup:visible')
    }
  }, [visible])

  useOnMount(() => {
    if (onAction) {
      onAction()
    }
  })

  useOnUnmount(() => {
    if (onCancel) {
      onCancel()
    }
  })

  return (
    <Modal
      popup
      visible={visible}
      maskClosable
      // animated={isMobile}
      animated={false}
      animationType="slide-up"
      onClose={onClickBettorHeartContentPopupCloseButton}
      css={AdvSlideUpModalStyle}
      className="slide-up pc-close-btn-modal"
    >
      <Button
        circle
        onClick={onClickBettorHeartContentPopupCloseButton}
        css={CloseBtn}
        className="close-btn modal-circle-close-btn">
        <span className="close-txt">닫기</span>
      </Button>
      <BettorGiftContent
        visible={visible}
        setVisible={setVisible}
        nick={nick}
        isCustomProfile={isCustomProfile}
        profile={profile}
      />
      <ModalBg onClick={onClickBettorHeartContentPopupCloseButton}/>
    </Modal>
  )
}

export default observer(BettorGiftContentPopup)
